// extracted by mini-css-extract-plugin
export default {"container":"Ai-z","blurb":"Bi-z","links":"Ci-z"};